import { __assign } from "tslib";
import { useEffect } from "react";
import { checkSupportWebp, WEBP_FEATURE } from "../helpers/checkSupportWebp";
import { useAuthData, } from "../providers/AuthDataProvider";
export var useSetSupportWebp = function () {
    var setAuthParams = useAuthData().setAuthParams;
    useEffect(function () {
        checkSupportWebp(WEBP_FEATURE.lossy, function (_, isSupportWebp) {
            setAuthParams(function (prev) { return (__assign(__assign({}, prev), { isSupportWebp: isSupportWebp })); });
        });
    }, []);
};
